import { AbstractDrawLinestring } from "../abstract-draw-linestring";

export class MeasureDrawLinestring extends AbstractDrawLinestring {

}
